module.exports = __webpack_public_path__ + "img/dispatch-icon4.488d2d07.png";